import React from 'react';
import './Sidebar.css';

interface SidebarProps {
  onNavigate: (path: string) => void;
  activePath: string;
  isOpen: boolean;
  toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onNavigate, activePath, isOpen, toggleSidebar }) => {
  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <h2
          onClick={e => {
            e.preventDefault();
            onNavigate('/');
          }}
          style={{ cursor: 'pointer' }}
        >
          Matthew Dabit's Portfolio
        </h2>
        <button className="close-sidebar-button" onClick={toggleSidebar} aria-label="Close sidebar">
          ✕
        </button>
      </div>
      <ul className="sidebar-nav">
        <li className="sidebar-nav-item">
          <button
            className={`sidebar-nav-link ${activePath === '/' ? 'active' : ''}`}
            onClick={() => onNavigate('/')}
            type="button"
          >
            Home
          </button>
        </li>
        <li className="sidebar-nav-item">
          <button
            className={`sidebar-nav-link ${activePath === '/resume' ? 'active' : ''}`}
            onClick={() => onNavigate('/resume')}
            type="button"
          >
            Resume
          </button>
        </li>
        <li className="sidebar-nav-item">
          <button
            className={`sidebar-nav-link ${activePath === '/research' ? 'active' : ''}`}
            onClick={() => onNavigate('/research')}
            type="button"
          >
            Research
          </button>
        </li>
        <li className="sidebar-nav-item">
          <button
            className={`sidebar-nav-link ${activePath === '/used-cars' ? 'active' : ''}`}
            onClick={() => onNavigate('/used-cars')}
            type="button"
          >
            Used Cars Price Predictor
          </button>
        </li>
        <li className="sidebar-nav-item">
          <button
            className={`sidebar-nav-link ${activePath === '/coupons' ? 'active' : ''}`}
            onClick={() => onNavigate('/coupons')}
            type="button"
          >
            Coupon Acceptance Predictor
          </button>
        </li>
        <li className="sidebar-nav-item">
          <button
            className={`sidebar-nav-link ${activePath === '/bank-marketing' ? 'active' : ''}`}
            onClick={() => onNavigate('/bank-marketing')}
            type="button"
          >
            Bank Marketing Predictor
          </button>
        </li>
        <li className="sidebar-nav-item">
          <button
            className={`sidebar-nav-link ${activePath === '/landmarks' ? 'active' : ''}`}
            onClick={() => onNavigate('/landmarks')}
            type="button"
          >
            Landmarks
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
